const CostWrapper = () => import('@/pages/chargeManagement/wrapper.vue');
const CostTab = () => import('../pages/CostExpenses/CostTab');
const CostDetail = () => import('../pages/PartyMembershipDues/PmdDetailsEmpty');
const CostChargeSchedule = () => import('../pages/PartyMembershipDues/PmdChargeSchedule');
const CostControl = () => import('../pages/PartyMembershipDues/PmdControl');
const CostAuditRecords = () => import('../pages/PartyMembershipDues/PmdAuditRecords');
const CostTicketManage = () => import('../components/otherTicketManage');

export default [
	{ path: '/CostHomePage', name: 'CostHomePage', component: CostWrapper, meta: { type: 'cost' } },
	{
		path: '/CostTab',
		component: CostTab,
		children: [
			{ path: '/', name: 'CostDetailsEmpty', component: CostDetail, meta: { parent: '/CostHomePage' } },
			{ path: 'CostProgress', name: 'CostProgress', component: CostChargeSchedule, meta: { parent: '/CostHomePage' } },
			{ path: 'CostControl', name: 'CostControl', component: CostControl, meta: { parent: '/CostHomePage' } },
			{ path: 'CostAuditRecords', name: 'CostAuditRecords', component: CostAuditRecords, meta: { parent: '/CostHomePage' } },
			{ path: 'CostTicketManage', name: 'CostTicketManage', component: CostTicketManage, meta: { parent: '/CostHomePage' } },
		],
	},
];
